import { request } from './request'

export interface DataPoint {
  label: string
  value: number
}

export interface DataMetric {
  metric: string
  today: string
  yesterday: string
  trend: string
}

export interface DataOverview {
  date: string
  revenueToday: number
  revenueYesterday: number
  orderCountToday: number
  orderCountYesterday: number
  refundCountToday: number
  refundCountYesterday: number
  metrics: DataMetric[]
}

export interface DataOrderAnalysis {
  paidCount: number
  cancelCount: number
  refundCount: number
  dailyOrders: DataPoint[]
  statusDistribution: DataPoint[]
}

export interface DataProductItem {
  productId: string
  productName?: string
  sales: number
  salesAmount: number
}

export interface DataProductAnalysis {
  movingProductCount: number
  bestSeller?: string
  bestSellerSales?: number
  slowMovingCount: number
  items: DataProductItem[]
}

export interface StoreRankItem {
  storeId: string
  storeName: string
  orderCount: number
  revenue: number
  avgPrice: number
}

export const dataApiReady = true as const

export const fetchDataOverview = async (): Promise<DataOverview> =>
  request<DataOverview>({
    url: '/data/overview',
    method: 'GET',
  })

export const fetchDataOrderAnalysis = async (): Promise<DataOrderAnalysis> =>
  request<DataOrderAnalysis>({
    url: '/data/orders',
    method: 'GET',
  })

export const fetchDataProductAnalysis = async (): Promise<DataProductAnalysis> =>
  request<DataProductAnalysis>({
    url: '/data/products',
    method: 'GET',
  })

export const fetchStoreRank = async (): Promise<StoreRankItem[]> =>
  request<StoreRankItem[]>({
    url: '/data/stores',
    method: 'GET',
  })
